import type { Item } from 'src/sdk/checkout/entity/orderForm'
import { SELLER_DECATHLON } from 'src/constants'
import type { PageTypeResult } from 'src/hooks/usePageType'
import {
  getBlogPageNumber,
  isBlogCategoryPath,
} from 'src/utils/analytics/blog/getBlogPageNumber'

import { formatDateWithTimezone } from '../formatDateWithTimezone'

export function getStandardObject(pagedata: PageTypeResult) {
  if (typeof document === 'undefined') {
    return null
  }

  const timestampIdentifier = Intl.DateTimeFormat().resolvedOptions().timeZone

  const currentLanguage = document?.documentElement?.lang ?? 'pt-br'
  const { pathname } = document.location
  const { search } = document.location
  const isCategoryListing = isBlogCategoryPath(pathname)
  const pageNumberViewed = isCategoryListing
    ? String(getBlogPageNumber(search))
    : null

  const standardObject = {
    'local timestamp': formatDateWithTimezone(),
    'local timestamp identifier': timestampIdentifier,
    'website domain': document.location.hostname,
    'page path': pathname,
    'page title': document.title,
    'page full url': document.location.href,
    'referring domain': document?.referrer ? document?.referrer : 'no_referrer',
    'full referrer':
      window?.previousPath?.href ?? document?.referrer === ''
        ? 'no_referrer'
        : document.referrer,
    'page name': pagedata?.currentPageName ?? '',
    'page type': pagedata?.currentPageType ?? '',
    'page language': currentLanguage.toLowerCase(),
    'previous page type': pagedata?.previousPageType ?? '',
    'previous page name': pagedata?.previousPageName ?? '',
    'page platform': 'vtex',
    'page number viewed': pageNumberViewed,
  }

  return {
    ...standardObject,
    'standard event properties': standardObject,
  }
}

export function checkPageType(pathName?: string) {
  const pageMap = {
    '/checkout/cart': 'carrinho',
    '/account': 'perfil do cliente',
    '/pesquisa': 'plp',
    '/marcas': 'plp',
    '/collection': 'plp',
    '/colecao': 'plp',
    '/p': 'pdp',
  }

  if (pathName === '/') {
    return 'home'
  }

  for (const [key, value] of Object.entries(pageMap)) {
    if ((pathName ?? document.location.pathname).includes(key)) {
      return value
    }
  }

  return 'public'
}

export function checkCartType(items: Item[] = []) {
  const hasDecathlon = items.find((item) => item?.seller === SELLER_DECATHLON)
  const hasMarketPlace = items.find((item) => item?.seller !== SELLER_DECATHLON)

  switch (true) {
    case hasDecathlon && !hasMarketPlace:
      return 'decathlon'

    case hasMarketPlace && !hasDecathlon:
      return 'marketplace'

    default:
      return 'mixed'
  }
}
